module.exports = __webpack_public_path__ + "media/images/sp/top/recommend-plan-text-wedding4-2656499a8a8959080910c9449487e010.png";